import en from "./en";
import cs from "./cs";

export default {
  en,
  cs,
};
